"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveClosures = void 0;
const dayjs = require("dayjs");
const getActiveClosures = (date, closures) => {
    if (!closures)
        return [];
    const day = dayjs(date).format("ddd");
    const active_closures = closures.filter((closure) => {
        // if the closure has a start date but no end date, then the closure is active if the date is after the start date
        if (closure.start_date && !closure.end_date) {
            if (dayjs(date).isAfter(dayjs(closure.start_date))) {
                return true;
            }
        }
        if (closure.start_date) {
            if (dayjs(date).isBefore(dayjs(closure.start_date)))
                return false;
        }
        if (closure.end_date) {
            if (dayjs(date).isAfter(dayjs(closure.end_date)))
                return false;
        }
        if (!closure.days[day.toLowerCase()])
            return false;
        return true;
    });
    return active_closures;
};
exports.getActiveClosures = getActiveClosures;
